
const tokenEstados = "9cd0f726-aaef-42d2-a00f-96fa42f271cc";

export default tokenEstados;